







































































































import {Component, Vue, Prop} from "vue-property-decorator";
import {Issue} from "@/models/issue";

@Component({
    name: 'IssueDetails'
})
export default class IssueDetails extends Vue {
    @Prop() issue!: Issue;
    @Prop() issues!: Array<Issue>;

}
